export * from './is-entity-collection';
